import axios from "axios";

const api = process.env.REACT_APP_GW3_API_URL;

export async function createMerchantUser(formData, ) {
  return await axios.post(
        `${api}/dashboard/merchant/account/create/`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
}